<style scoped lang="less">
  .form-card {
    background: #fff;
    margin-bottom: 24px;
    &-title {
      height: 55px;
      line-height: 55px;
      padding-left: 32px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #e9e9e9;
    }
    &-content {
      padding: 24px;
    }
  }

  .form-bottom-tool {
    padding: 16px 32px;
    background: #fff;
    border-top: 1px solid #E8E8E8;
  }
</style>
<template>
  <div>
    <Form ref="formValidate" :model="form" :rules="ruleValidate" :label-width="80" style="padding:24px;width:100%">
      <div class="form-card">
        <div class="form-card-title">目标类型</div>
        <div class="form-card-content">
          <FormItem prop="inputType" :label-width="1">
            <RadioGroup v-model="form.inputType" :style="{width:'100%'}">
              <Radio label="iqiyi_15">
                <span>爱奇艺15秒</span>
              </Radio>
              <Radio label="iqiyi_30">
                <span>爱奇艺30秒</span>
              </Radio>
              <Radio label="tencent_15">
                <span>腾讯15秒</span>
              </Radio>
              <Radio label="tencent_30">
                <span>腾讯30秒</span>
              </Radio>
              <Radio label="youku_15">
                <span>优酷15秒</span>
              </Radio>
              <Radio label="youku_30">
                <span>优酷30秒</span>
              </Radio>
              <Radio label="mongo_15">
                <span>芒果15秒</span>
              </Radio>
              <Radio label="mongo_30">
                <span>芒果30秒</span>
              </Radio>
              <Radio label="fengxing_15">
                <span>风行15秒</span>
              </Radio>
              <Radio label="sohu_15">
                <span>搜狐15秒</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">替换背景</div>
        <div class="form-card-content">
          <RadioGroup v-model="form.backgroundType" vertical :style="{width:'100%'}">
            <Radio label="url" :style="{marginBottom:'15px'}">
              <FormItem prop="url" label="URL" :style="{display:'inline-block', width:'80%'}">
                <Input v-model="form.backgroundUrl" placeholder="请输入目标文件地址"
                       :disabled="form.backgroundType==='file'"></Input>
              </FormItem>
            </Radio>
            <Radio label="file" style="height: auto;">
              <FormItem label="上传" prop="format" :style="{display:'inline-block', width:'80%'}">
                <Upload ref="background" :action="uploadUrl"
                        :on-success="uploadBackgroundSuccess"
                >
                  <Button type="ghost" icon="ios-cloud-upload-outline" :disabled="form.backgroundType==='url'">上传
                  </Button>
                </Upload>
              </FormItem>
            </Radio>
          </RadioGroup>
        </div>
      </div>
    </Form>
    <div class="form-bottom-tool">
      <Button type="primary" @click="submitForm">提交</Button>
    </div>
  </div>
</template>
<script>
  import {
    UPLOAD_URL,
    CREATE_FACTORY
  } from '@/utils/api';

  export default {
    data() {
      return {
        data: [],
        uploadUrl: UPLOAD_URL,
        background: '',
        form: {
          backgroundType: 'url',
          backgroundFile: '',
          backgroundUrl: '',
        },
        urls: [ "" ],
        ruleValidate: {
          inputType: [ {
            required: true, message: '类型不能为空', trigger: 'blur'
          } ]
        },
      };
    },
    computed: {
      backgroundUrl() {
        return this.form.backgroundType === 'url' ? this.form.backgroundUrl : this.form.backgroundFile
      }
    },
    methods: {
      uploadBackgroundSuccess(response, file, fileLis) {
        this.form.backgroundFile = file.response.data
        this.$refs.background.fileList = [ file ]
      },
      submitForm() {
        this.$refs.formValidate.validate((valid) => {
          if (valid) {
            if (this.backgroundUrl) {
              this.$Spin.show();
              this.$http.post(CREATE_FACTORY, {
                type: this.form.inputType,
                videoUrl: this.backgroundUrl
              }).then(({data}) => {
                if (data.code === 0) {
                  this.$Message.success('保存成功')
                  // this.$router.push('/cutout/list')
                  this.$Modal.confirm({
                    title: '生成结果',
                    content: '视频地址:<a href="'+data.data.videoUrl+'" target="_blank">' + data.data.videoUrl + '</a>'
                  });
                } else {
                  this.$Message.error(data.errorMessage)
                }
                this.$Spin.hide();
              }).catch(()=>{
                this.$Spin.hide();
              })
            }
          }
        })

      }
    }
  };
</script>
